import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './manage-access-to-report.component.scss';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import * as $ from 'jquery';
var ManageAccessToReport = /** @class */ (function (_super) {
    tslib_1.__extends(ManageAccessToReport, _super);
    function ManageAccessToReport(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    ManageAccessToReport.prototype.init = function () {
        //Modal
        this.modals = Array.from(this.element.querySelectorAll('.js-rich-text-modal-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-rich-text-modal-modal-open'));
        this.closeButton = Array.from(this.element.querySelectorAll('.js-rich-text-modal-modal-close'));
        // containers
        this.containerFields = this.element.querySelector(".form__fields--container");
        this.containerModal = this.element.querySelector(".js-apply-now-modal");
        //Button submit
        this.buttonSubmit = this.element.querySelector(".js-submit");
        // the form
        this.form = this.element.querySelector("form");
    };
    ManageAccessToReport.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModals(event);
        }); });
        this.closeButton.map(function (item) { return item.addEventListener('click', function (event) {
            _this.closeModal();
        }); });
        this.buttonSubmit.addEventListener("click", function (event) {
            var formFields = _this.form.querySelectorAll('input');
            var validation = _this.validationService.validateEnterprise(formFields);
            if (validation.valid) {
                _this.action(_this.form);
            }
        });
    };
    ManageAccessToReport.prototype.action = function (form) {
        var fieldsInputs = Array.from(form.querySelectorAll('input, select, textarea'));
        var activeModal = this.containerModal;
        activeModal.classList.remove('modal--closed');
        activeModal.classList.add('js-rich-text-modal-modal--opened');
        var postData = '';
        var fields = [];
        fieldsInputs.map(function (field) {
            var getName = field.getAttribute('name');
            var getType = field.getAttribute('type');
            var getValue = field.value;
            getName = getName.replace(' ', '_');
            if (fields[getName]) {
                var currentValue = fields[getName].value;
                if (getType === 'checkbox') {
                    if (field.checked) {
                        currentValue += ',' + field.value;
                    }
                }
                else if (getType === 'radio') {
                }
                else {
                    currentValue += ',' + field.value;
                }
                fields[getName].value = currentValue;
            }
            else {
                if (getType === 'radio') {
                    var radioButtons = Array.from(form.querySelectorAll("input[name='" + getName + "']"));
                    radioButtons.map(function (button) {
                        if (button.checked) {
                            getValue = button.value;
                        }
                    });
                }
                fields[getName] = {
                    name: getName,
                    value: getValue
                };
            }
        });
        var objectKeys = Object.keys(fields);
        objectKeys.forEach(function (key) {
            postData += key + '=' + fields[key].value + '&';
        });
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitGenericForm.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            form.reset();
            activeModal.classList.remove('modal--closed');
            analyticsService.dtmFormComplete('complete', '');
        }).catch(function (response) {
            // service failed
            form.reset();
            activeModal.classList.remove('modal--closed');
            analyticsService.dtmFormComplete('complete', '');
        });
    };
    ManageAccessToReport.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    ManageAccessToReport.prototype.closeModal = function () {
        var _this = this;
        if (this.activeModal) {
            this.activeModal.classList.add('modal--close');
        }
        else {
            this.activeModal = this.element.querySelector('.js-rich-text-modal-modal--opened');
            this.activeModal.classList.add('modal--close');
        }
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    ManageAccessToReport.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-rich-text-modal-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    ManageAccessToReport.prototype.openModal = function () {
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
        // this.activeModal.classList.add('d-block');
    };
    ManageAccessToReport.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    return ManageAccessToReport;
}(Base));
export { ManageAccessToReport };



//////////////////
// WEBPACK FOOTER
// ./components/manage-access-to-report/manage-access-to-report.component.ts
// module id = 691
// module chunks = 0